import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Building2, MapPin, Phone, Mail, Calendar } from 'lucide-react';
// @ts-ignore - TODO: Fix this TypeScript error
import type { Property } from '@/lib/types';

interface PropertyDetailsProps {
  property: Property;
  onEdit: () => void;
}

export function PropertyDetails({ property, onEdit }: PropertyDetailsProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>{property.name}</CardTitle>
        <Button onClick={onEdit} variant="outline">
          Edit Property
        </Button>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-6">
          <div className="p-4 bg-primary/10 rounded-lg">
            <Building2 className="h-8 w-8 text-primary" />
          </div>
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <h2 className="text-xl font-semibold">{property.name}</h2>
              <Badge variant={property.status === 'active' ? 'default' : 'secondary'}>
                {property.status}
              </Badge>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <MapPin className="h-4 w-4" />
              <span>{property.address}</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div className="rounded-lg border p-4">
            <div className="text-sm text-muted-foreground">Property Type</div>
            <div className="mt-1 font-medium capitalize">{property.type}</div>
          </div>
          <div className="rounded-lg border p-4">
            <div className="text-sm text-muted-foreground">Size</div>
            <div className="mt-1 font-medium">{property.size.toLocaleString()} sq.ft.</div>
          </div>
          <div className="rounded-lg border p-4">
            <div className="text-sm text-muted-foreground">Units</div>
            <div className="mt-1 font-medium">{property.units || 'N/A'}</div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Main Contact</h3>
          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">Name</div>
              <div>{property.mainContact.name}</div>
            </div>
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">Phone</div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                <span>{property.mainContact.phone}</span>
              </div>
            </div>
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">Email</div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-muted-foreground" />
                <span>{property.mainContact.email}</span>
              </div>
            </div>
          </div>
        </div>

        {property.lastService && (
          <div className="border-t pt-6">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Calendar className="h-4 w-4" />
              <span>Last service: {new Date(property.lastService).toLocaleDateString()}</span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}